var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BAC9FF",
    d: "M1.42 33.393a.75.75 0 1 0-.134 1.494zM84.98.863a.75.75 0 0 0-.805-.69l-6.73.52a.75.75 0 1 0 .115 1.495l5.982-.462.462 5.982a.75.75 0 0 0 1.496-.115zM1.286 34.887c25.488 2.273 46.369-6.102 60.86-15.027 7.248-4.463 12.904-9.068 16.751-12.56a90 90 0 0 0 4.39-4.248 56 56 0 0 0 1.415-1.528l.074-.085.02-.022.005-.006.001-.002-.569-.489-.57-.488v.001l-.004.004-.016.02-.067.076q-.09.104-.274.307c-.244.27-.611.667-1.097 1.173a88 88 0 0 1-4.316 4.177c-3.792 3.442-9.376 7.987-16.529 12.392C47.053 27.395 26.493 35.63 1.42 33.394z"
  })));
};
export default SvgRightArrow;